export default "__VITE_ASSET__o90MdFtw__"